import { IResourceComponentsProps } from "@refinedev/core";
import { AntdCreateInferencer } from "@refinedev/inferencer/antd";
import Cw8Create from "components/cw8/Cw8Create";

export const SeccionInfografiasCreate: React.FC<IResourceComponentsProps> = () => {
  // return <AntdCreateInferencer />;
  const resourceName :string = 'seccionInfografia';
  return (
    <Cw8Create
      resourceName = {resourceName}
    ></Cw8Create>
  );
};
